<template>
  <input
    v-mask="mask"
    :value="props.value"
    placeholder="0.00"
    class="input"
    autocomplete="off"
    autocapitalize="off"
    autocorrect="off"
    spellcheck="false"
    pattern="^[0-9]+([\.,][0-9]+)?$"
    inputmode="decimal"
    @accept="onAccept"
  />
</template>

<script lang="ts" setup>
import { IMaskDirective as vMask } from 'vue-imask';

const props = withDefaults(defineProps<{
  value: string,
  digits: number,
}>(), {
  digits: 2,
});

const emit = defineEmits<{
  (e: 'input', value: string): void,
}>();

const mask = {
  mask: [
    {
      mask: Number,
      scale: 2,
      radix: '.',
      mapToRadix: ['.', ','],
      normalizeZeros: false,
      min: 0,
    },
    {
      mask: Number,
      scale: 8,
      radix: '.',
      mapToRadix: ['.', ','],
      normalizeZeros: false,
      min: 0,
    },
  ],
  dispatch: (a, dynamicMasked) => dynamicMasked.compiledMasks.find(m => m.scale === props.digits),
};

const onAccept = (e) => {
  while (e.detail.value.match(/^0\d/) || e.detail.value.startsWith('.')) {
    e.detail.value = e.detail.value.slice(1);
  }

  const value = e.detail.value;

  if (props.value !== value && Number.parseFloat(props.value) !== Number.parseFloat(value)) {
    emit('input', value);
  }
};
</script>

<style scoped lang="scss">
@use '@kanoAssets/styles/breakpoints.scss';

.input {
  width: 100%;
  min-width: 0;
  font-size: 16px;
  line-height: 24px;

  &:focus {
    outline: none;
  }

  &::-webkit-contacts-auto-fill-button {
    visibility: hidden;
  }

  @include breakpoints.desktop {
    font-size: 18px;
    line-height: 26px;
  }
}
</style>